import React from "react";
import { CheckoutStyled } from "./CheckoutStyled";
import Typography from "../../UI/Typography";
import { TYPOGRAPHY_TYPE } from "../../entities/Typography";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../Mixture/selectors";
import MixtureTabItem from "../MixtureTab/MixtureTabItem";
import { MixtureTabItemsStyled } from "../MixtureTab/MixtureTabStyled";
import CheckoutList from "./CheckoutList/CheckoutList";
import CheckoutInfo from "./CheckoutInfo";
import CheckoutHandler from "./CheckoutHandler/CheckoutHandler";
import {
  getCalculationLoading,
  getInitialCalculationIsCompleted,
} from "../Calculation/slice/selectors";
import CheckoutListSkeleton from "./CheckoutList/CheckoutListSkeleton";

const Checkout: React.FC = () => {
  const { name, condiments } = useSelector(getDataFromMixture);
  const isLoadingCalculation = useSelector(getCalculationLoading);
  const initialCalculationIsCompleted = useSelector(
    getInitialCalculationIsCompleted,
  );
  const isLoading = isLoadingCalculation || !initialCalculationIsCompleted;
  return (
    <CheckoutStyled>
      <div className="checkout-title">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FOUR}>{name}</Typography>
      </div>

      <MixtureTabItemsStyled>
        {condiments.map((condiment) => (
          <MixtureTabItem
            key={condiment.id}
            name={condiment.name}
            image={condiment.image}
          />
        ))}
      </MixtureTabItemsStyled>

      <CheckoutInfo />

      {isLoading ? <CheckoutListSkeleton /> : <CheckoutList />}

      <CheckoutHandler />
    </CheckoutStyled>
  );
};

export default Checkout;
